import { render, staticRenderFns } from "./FrequencyPeakAnalyzeAlarmInput.vue?vue&type=template&id=5dd6a3bc"
import script from "./FrequencyPeakAnalyzeAlarmInput.vue?vue&type=script&lang=js"
export * from "./FrequencyPeakAnalyzeAlarmInput.vue?vue&type=script&lang=js"
import style0 from "./FrequencyPeakAnalyzeAlarmInput.vue?vue&type=style&index=0&id=5dd6a3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports